import { render } from "./HistoriaFrenkel.vue?vue&type=template&id=7bbff6ee&scoped=true"
import script from "./HistoriaFrenkel.vue?vue&type=script&lang=js"
export * from "./HistoriaFrenkel.vue?vue&type=script&lang=js"

import "./HistoriaFrenkel.vue?vue&type=style&index=0&id=7bbff6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbff6ee"]])

export default __exports__